// extracted by mini-css-extract-plugin
module.exports = {"whatPaidy":"WhatPaidy-module--whatPaidy--3WS2f","row":"WhatPaidy-module--row--Hb4NR","text":"WhatPaidy-module--text--3-jlU"};